/**
 * @deprecated Import from caseFileUploadService.js — kept for backward compatibility.
 */
import caseFileUploadService, {
  uploadScan,
  uploadPhoto,
  uploadDocument,
} from './caseFileUploadService';

class S3UploadService {
  uploadScan(file, patientId, caseId, scanType, userId, options) {
    return uploadScan(file, patientId, caseId, scanType, userId, options);
  }

  uploadPhoto(file, patientId, caseId, photoType, category, userId, options) {
    return uploadPhoto(file, patientId, caseId, photoType, category, userId, options);
  }

  uploadDocument(file, patientId, caseId, documentType, userId, options) {
    return uploadDocument(file, patientId, caseId, documentType, userId, options);
  }
}

export default new S3UploadService();
export { caseFileUploadService };
